export default [
  'acho',
  'pijo',
  'chacho',
  'chacha',
  'limón',
  'las corvas',
  'está enrobinao',
  'un poquico cascaruja',
  'cómete unos crespillos',
  'cómete unos paparajotes',
  'mar menor',
  'mar mayor',
  'bonico',
  'bonica',
  'a capuzarse',
  'coscoletas',
  'chuminá',
  'que desaborío',
  'que desaboría',
  'estoy esmallao',
  'para la plaza las flores',
  'la redonda',
  'estoy esmallá',
  'mucho pesambre',
  'que solanera',
  'está esturreao',
  'sin fuste',
  'una panzá',
  'que emperifollao',
  'que emperifollá',
  'hace picoesquina',
  'enrevesaos',
  'échale limón',
  'menudo zarangollo tienes montao en la cabeza',
  'aquí llega el follonero',
  'me he pegao una panzá de comer',
  'será ejraciao',
  'coger un ojico de sol',
  'vamos para larrisaca',
  'el zagal',
  'la zagala',
  'el zagalico',
  'la zagalica',
  'chacho',
  'chacha',
  'que zagal más bonico',
  'que zagala más bonica',
  'una miaja',
  'ponme una docena de paparajotes',
  'un cafetico de olla',
  'está esfarriao',
  'hace solanera',
  'ahí esclafá toda la tarde',
  'ha llenado las lejas de libros',
  'menudo mindango estás hecho',
  'acho, ¿Qué ha sido ese zurrío?',
  'ponme una marinera',
  'unas papas con berberechos y limón',
  'un pastelico carne',
  'que nos vemos en la catedral',
  'chambi'
]
